import { InputAdornment, TextField } from "@mui/material";
import DotFlashing from "../DotFlashing";

const LoadingInput = ({
  value,
  placeholder = "",
  disabled = false,
  loading = false,
  helperText = "",
  error = false,
}) => {
  return (
    <TextField
      value={value}
      variant="outlined"
      sx={{ color: "#333333" }}
      InputProps={{
        style: {
          color: "#333333",
          WebkitTextFillColor: "#333333",
        },
        startAdornment: loading && (
          <InputAdornment
            position="start"
            sx={{ marginLeft: "8px", marginRight: "16px" }}
          >
            <DotFlashing />
          </InputAdornment>
        ),
      }}
      error={error}
      placeholder={placeholder}
      disabled={disabled}
      helperText={helperText}
      fullWidth
    />
  );
};

export default LoadingInput;
